import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import SignupForm from '../components/SignupForm';
import LoginForm from '../components/LoginForm';
import { push } from 'react-router-redux';
import { pushState } from 'redux-router';
import {
  doSignupUser,
  doFBLogin,
  loadCollageOrganizations,


} from '../actions';
import HomeCollage from '../components/HomeCollage';


function mapStateToProps (state) {
  return state
}

@connect(mapStateToProps, { doSignupUser, doFBLogin, push, pushState, loadCollageOrganizations })
class Join extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: 'signup'
    }
  }

  ensureAnonymous = (props) => {
    const { auth, location } = props
    if (!auth.isLoading && auth.user) {
      const { flow } = auth.user.depot
      let nextUrl = ''
      if (flow && flow.length > 0) {
        nextUrl = flow[0]
      }
      else if (location && location.query.next) {
        nextUrl = location.query.next
      } else {
        nextUrl = '/my'
      }
      this.props.push(nextUrl)
    }
  }

  setTabState = (props) => {
    const { location } = props
    if (location.pathname.endsWith('login')) {
      this.setState({ tab: 'login' })
    } else {
      this.setState({ tab: 'signup'})
    }
  }
  componentWillMount() {
    this.setTabState(this.props)
  }

  componentDidMount() {
    this.ensureAnonymous(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setTabState(nextProps)
    this.ensureAnonymous(nextProps)
  }

  componentWillUnmount() {}

  render() {
    const { browser, location, signup } = this.props

    let signupForm = (
        <SignupForm signup={signup}
                    doSignupUser={this.props.doSignupUser}
                    doFBLogin={this.props.doFBLogin}
                    location={location} />
    )

    let loginForm = (
      <LoginForm />
    )

    let form = signupForm
    let tabSignupActive = 'active'
    let tabLoginActive = ''
    let loginUrl = `/login${location.search}`
    let signupUrl = `/join${location.search}`
    let seoTitle = 'WorldWideWomen | Join and get resources'
    let seoDescription = 'Become a WorldWideWomen for free! Build your profile, tell us your interests and connect with resources for women from around the world. Sign up now.'

    let headline = 'Sign up to receive special members-only benefits'
    let headlineSubText = 'Previews of new resources, inspiring stories and podcasts, invitations to local events, and more.'


    // Set Header copy for recommended link if user not logged in
    if (this.props.routing.locationBeforeTransitions.query.next == '/organizations/new') {
      headline = 'In order to add a resource, please join us to receive special members-only benefits';
    }

    if (location.query.flow) {
      switch (location.query.flow) {
        case 'claim':
          headline = 'Claim your organization on WorldWideWomen'
          headlineSubText = 'Before we proceed with your claim, please signup to become a WorldWideWomen member or log in'
          break
        case 'apply':
          headline = 'Apply to list your services on WorldWideWomen!'
          headlineSubText = 'A powerful resource to connect to women around the world'

          seoTitle = 'Apply to be listed in global women’s directory'
          seoDescription = 'List your company, organization or service on WorldWideWomen, a global online directory for women. Promote your business and connect with customers.'
          break
      }
    }

    if (location.search.indexOf('survey-redirect') > -1) {
      headline = 'Share your feedback win a prize!'
      headlineSubText = 'Before we begin, please sign up to become a WorldWideWomen member or log in.'
    }

    let headlineMarkup = (
      <h2 className='headline'>
        {headline}
        <br />
        <small className='headlineSubtext'> {headlineSubText} </small>
      </h2>
    )

    if (this.state.tab === 'login') {
      form = loginForm
      tabLoginActive = 'active'
      tabSignupActive = ''
      headlineMarkup = (
        <h2 className='headline'>
          Already a member? <span style={ {whiteSpace: 'nowrap'} }>Log in.</span>
        </h2>
      )
    }

    let forms = (
      <div className="tabsContainer">
        <div className="tabContent">
          {form}
        </div>
      </div>
    )

    const meta = {
      title: seoTitle,
      description: seoDescription,
      canonical: 'https://worldwidewomen.co/join',
    }

    let buttonCollage = '';
    let collageTextTitleMarginBottomProp = '0px';

    return (
      <div className="pageContainer">
        <DocumentMeta {...meta} />
        <div className="collage-wrapper">
          <HomeCollage collageOrganizations={this.props.collageOrganizations}
                       loadCollageOrganizations={this.props.loadCollageOrganizations}
                       browser={this.props.browser}
                       auth={this.props.auth}
                       buttonCollage={buttonCollage}
                       header='Join the WorldWideWomen community!'
                       />
        </div>
        <div className="page join">
          {headlineMarkup}
          {forms}
        </div>
      </div>
    )
  }
}

export default Join



// WEBPACK FOOTER //
// ./src/containers/NewJoin.jsx